import { useEffect, useState} from "react";
import useApiCallService from "../../Common/Helpers/ApiCall";
import SortableList from "../../Common/Components/Lists/SortableList";
import {CustomButton} from "../../Common/Components/Button/CustomButton";
import {Button, Card, Col, Row} from "reactstrap";
import {useNavigate} from "react-router-dom";
import {ADMIN_PATHS} from "../../config";
import AdminResponseActivityCalendar from "../Models/Response/AdminResponseActivityCalendar";
import {useTranslation} from "react-i18next";
import {CheckUserRole} from "../../AppSystem/Helpers/CheckUserRole";
import {ToCustomDecimal} from "../../AppSystem/Helpers/ToCustomDecimal";
import {CheckUserPermission} from "../../AppSystem/Helpers/CheckUserPermission";
import {UrlStructure} from "../../AppSystem/Helpers/UrlStructure";
import { CustomModal } from "../../Common/Components/Modal/CustomModal";
import { CustomReload } from "../../AppSystem/Helpers/CustomReload";
import { FlashMessage } from "../../Common/Helpers/FlashMessage";
import { useHeader } from "../../Auth/Components/Nav/HeaderContext";

const AdminCalendarActivityList = ({ userId = null, isSuperAdmin = null, setActiveTab = null, returnPath = null }) => {
    isSuperAdmin = CheckUserRole("SuperAdmin");
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { ApiCall } = useApiCallService();
    const [displayDeleteModal, setDisplayDeleteModal] = useState(false);
    const [deleteApiResponse, setDeleteApiResponse] = useState(null);
    const [activityCalendarId, setActivityCalendarId] = useState(null);

    const { setPageTitle, setPageTitleKey} = useHeader();

    useEffect(() => {
        setPageTitle(t('modelLabel.activityCalendarTitle'));
        setPageTitleKey('modelLabel.activityCalendarTitle');
        return () => { setPageTitle(''); setPageTitleKey(''); };
    }, [t]);

    let idFromUrl = '';
    if (window.location.pathname.includes('admin/user-list/user')) {
        idFromUrl = new URLSearchParams(window.location.search).get('id');
    }
    const baseUrl = "/roten/admin/search/filter";

    const renderActionColumn = (item) => {
        return (
            <>            
            <CustomButton icon = "bx bx-show py-1" iconColor="#157553" hoverIconColor='white' hoverButtonColor='#A3C2B8' iconSize={4}  buttonColor="#cde0da"  tooltipText={t('button.info')} customClasses="rounded" buttonBorder={false} id={item.id} 
            onClick={() => {
                navigate(`${ADMIN_PATHS.ADMIN_CALENDAR_ACTIVITY_INFO}?id=${item.id}`, {
                state: { returnTo: returnPath, userId: userId }
                });
            }} />
            </>
        );
    }

    const updateActivitiesCalendarjob = async () => {
            try {
                const jsonData = {
                    "Changed": new Date().toISOString()
                }
            
                const apiCallOptions = {
                    method: "post",
                    url: `/roten/activity`,
                    data: jsonData
                };
                try {
                    ApiCall(apiCallOptions, (response) => {
                        FlashMessage('Aktiviteter har uppdaterats', 'flash-messageSuccess');
                        setTimeout(()=>{
                            CustomReload();
                        },2000);
                    });
                } catch (error) {
                    console.log(error);
                    FlashMessage('Det uppstod ett problem, försök igen senare. ', 'flash-messageError');
                }
            } catch (err) {
                console.log(err);
            }
        };    

    useEffect(() => {
        if (deleteApiResponse !== null) {
            try {
                if (typeof window !== 'undefined' && window.localStorage) {
                    Object.keys(window.localStorage).forEach(key => {
                        if (key.startsWith('calendarActivityList')) {
                            window.localStorage.removeItem(key);
                        }
                    });
                }
            } catch (e) {
                console.warn('Error clearing calendarActivityList keys from localStorage', e);
            }

            CustomReload(ADMIN_PATHS.ADMIN_CALENDAR_ACTIVITY_LIST);
        }
    }, [deleteApiResponse]);

    const columns = [
        "activityId",
        "activityName",
        "organizer",
        "status",
        "datetimeActivityFrom",
        "datetimeUpdate"
    ];

    const columnsToExport = ["activityId", "activityName","organizer", "costPlace",  'status', "datetimeActivityFrom", "datetimeUpdate"];

    if (isSuperAdmin === true) {
        columns.unshift('id');
    }
    const listOptions = {
        "model": AdminResponseActivityCalendar,
        "columns": columns,
        "actions": {
            "actionColumn" : renderActionColumn,
        },
        "exportIsAvailable": true,
        "urlGetListItemsToExport": baseUrl + (idFromUrl ? `?id=${idFromUrl}` : ''),
        "nameFile": t('modelLabel.activityCalendarTitle'),
        "ignoreFields" : columnsToExport,
        "modelType" : "ActivityCalendar",
        "filterTestIsAvailable": true,
        "urlGetSearch" : baseUrl,
        "viewName": "AdminCalendarActivity",
        "ignoreUrlParams": !!idFromUrl,

    };

    return (
        <Col lg="12" className='card card-backend p-4 mb-5'>       
                <Row>
                    <Col lg={9}>
                    <h2 className="pb-2 ps-1 rokkitt-font">{t('modelLabel.activityCalendarTitle')}</h2>
                  
                    </Col>  
                    <Col lg={3} className="text-end d-flex align-items-center justify-content-end">                   
                        <>
                            <Button
                                className="bg-green mb-2 mt-2 ms-2"
                                onClick={updateActivitiesCalendarjob}
                                style={{ minWidth: "240px", whiteSpace: "nowrap" }}
                            >
                                Uppdatera aktiviteter
                            </Button>
                        </>                
                    </Col>  
                </Row>
                <SortableList
                    listOptions={listOptions}
                />
        </Col>
    );
};
export default AdminCalendarActivityList;